const filter = document.querySelector("[data-js='filter']");
const filterSelectionButton = document.querySelector("#m-f-selection-btn");
const filterSelectionButtonDesktop = document.querySelector(
  "#m-f-selection-btn-desktop"
);
const filterSortButton = document.querySelector("#m-f-sort-btn");
const filterSortButtonDesktop = document.querySelector("#m-f-sort-btn-desktop");
const filterMapButton = document.querySelector("#m-f-map-btn");
const filterMapButtonDesktop = document.querySelector("#m-f-map-btn-desktop");
const filterSelectionReset = document.querySelector(
  "#list-filter-selection-reset"
);
let filterListItemSelection = document.querySelectorAll(
  ".list-filter-selection-item"
);
let filterListGroupSub = document.querySelector(".list-group__sub");

// Funktion zur Aktualisierung der Auswahl
function updateSelection() {
  let checkCountAll = document.querySelectorAll(
    "input[type='checkbox']:checked"
  ).length;
  if (checkCountAll > 0) {
    filterSelectionButton.querySelector("span").classList.add("active");
    filterSelectionButtonDesktop.querySelector("span").classList.add("active");
  } else {
    filterSelectionButton.querySelector("span").classList.remove("active");
    filterSelectionButtonDesktop
      .querySelector("span")
      .classList.remove("active");
  }
}

// Funktion zur Aktualisierung der Checkcounts
function updateCheckCounts() {
  filterListItemSelection.forEach((item) => {
    let checkCount = item.querySelectorAll("input[type='checkbox']:checked")
      .length;

    if (checkCount > 0) {
      item.querySelector(".checkcount").classList.add("show");
      item.querySelector(".checkcount").innerHTML = checkCount;
    } else {
      item.querySelector(".checkcount").classList.remove("show");
    }
  });
}

// When Filter exists
if (filter) {
  filterSelectionButton.addEventListener("click", function () {
    $("#m-f-selection").modal("show");
    updateCheckCounts(); // Aktualisierung der Checkcounts aufrufen
  });

  if (filterSelectionButtonDesktop) {
    filterSelectionButtonDesktop.addEventListener("click", function () {
      $("#m-f-selection").modal("show");
      updateCheckCounts(); // Aktualisierung der Checkcounts aufrufen
    });
  }

  filterSortButton.addEventListener("click", function () {
    $("#m-f-sort").modal("show");
  });

  if (filterSortButtonDesktop) {
    filterSortButtonDesktop.addEventListener("click", function () {
      $("#m-f-sort").modal("show");
    });
  }

  filterMapButton.addEventListener("click", function () {
    $("#m-f-map").modal("show");
    updateSelection(); // Aktualisierung der Auswahl aufrufen
    updateCheckCounts(); // Aktualisierung der Checkcounts aufrufen
  });

  if (filterMapButtonDesktop) {
    filterMapButtonDesktop.addEventListener("click", function () {
      $("#m-f-map").modal("show");
      updateSelection(); // Aktualisierung der Auswahl aufrufen
      updateCheckCounts(); // Aktualisierung der Checkcounts aufrufen
    });
  }

  filterListItemSelection.forEach((item) => {
    let filterListItemSelectionCheckboxes = item.querySelectorAll(
      "input[type='checkbox']"
    );
    filterListItemSelectionCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        updateCheckCounts(); // Aktualisierung der Checkcounts aufrufen
        updateSelection(); // Aktualisierung der Auswahl aufrufen
      });
    });
  });

  filterSelectionReset.addEventListener("click", function () {
    let uncheck = document.querySelectorAll("input[type='checkbox']");
    let filterCheckcountItem = document.querySelectorAll(".checkcount");

    [].forEach.call(filterCheckcountItem, function (el) {
      el.classList.remove("show");
    });

    uncheck.forEach((checkbox) => {
      checkbox.checked = false;
    });

    updateCheckCounts(); // Aktualisierung der Checkcounts aufrufen
    updateSelection(); // Aktualisierung der Auswahl aufrufen
  });

  let coll = document.getElementsByClassName("collapsible");
  for (let collCount = 0; collCount < coll.length; collCount++) {
    coll[collCount].addEventListener("click", function () {
      this.classList.toggle("active");
      let content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  }
}

$(".list-group__sub")
  .on("shown.bs.collapse", function () {
    let parentContent = this.closest(".content.list-group");
    let content = this;

    parentContent.style.maxHeight =
      content.scrollHeight + parentContent.scrollHeight + "px";
  })
  .on("hide.bs.collapse", function () {
    let items = this.querySelectorAll(".vh");
    for (let i = 0; i < items.length; i++) {
      if (items[i].type === "checkbox") {
        items[i].checked = false;
      }
    }
  });
